module.exports = __webpack_public_path__ + "397c6f61969939b746ea641087f854f5.MP3";